export default __webpack_public_path__ + "static/www3-e2fdee6607468085c8a757be2a486781.png";